module.exports = __webpack_public_path__ + "img/BANNER PROVISIONAL.c2e12c74.jpg";